import { Steps } from 'antd';
import { observer } from 'mobx-react-lite';
import { Step } from 'rc-steps';
import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { FormStatus } from 'entities/common';
import { useBasicFormStore } from 'stores/local';
import {
  FORM_STEPS,
  REVERSE_STEPPER,
  STEPS_TO_RENDER,
} from 'stores/local/forms/BasicFormStore/config';

const STEP_KEYS: Record<string, string> = {
  [FormStatus.DRAFT]: 'formStepper.createForm',
  [FormStatus.FILE_UPLOAD]: 'formStepper.fillForm',
  [FormStatus.VALIDATION]: 'formStepper.verifyAndPublish',
};

const FormStatusStepper: React.FC = () => {
  const { t } = useTranslation();
  const store = useBasicFormStore();

  const stepIndex = React.useMemo(() => {
    if (!store.status || !FORM_STEPS[store.status]) {
      return 0;
    }

    return FORM_STEPS[store.status];
  }, [store.status]);

  const handleStepChange = React.useCallback(
    async (current: number) => {
      const status = REVERSE_STEPPER[current];

      await store.updateFormStatus(status);
    },
    [store]
  );

  return (
    <Steps onChange={handleStepChange} current={stepIndex} size="small">
      {Object.keys(STEPS_TO_RENDER).map((s, index) => (
        <Step disabled={index - stepIndex > 1} key={s} title={t(STEP_KEYS[s])} />
      ))}
    </Steps>
  );
};

export default observer(FormStatusStepper);
